import { render, staticRenderFns } from "./protocollist.vue?vue&type=template&id=ccf1fb24&scoped=true&"
import script from "./protocollist.vue?vue&type=script&lang=js&"
export * from "./protocollist.vue?vue&type=script&lang=js&"
import style0 from "./protocollist.vue?vue&type=style&index=0&id=ccf1fb24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf1fb24",
  null
  
)

component.options.__file = "protocollist.vue"
export default component.exports